import React from 'react';
import Icon from '../../Icon';
var dragRowKey;
var COUNT = Symbol('count');

function getTarget(classname, node) {
  var targetNode = node;

  while (targetNode && !targetNode.classList.contains(classname)) {
    targetNode = targetNode.parentNode;
  }

  return targetNode;
}

function setDragCls(target, type) {
  var from = dragRowKey;
  var to = target.getAttribute('data-row-key');
  var cls;

  if (from === to) {
    cls = '';
  } else if (from > to) {
    cls = 'jmtd-drop-over-upward';
  } else {
    cls = 'jmtd-drop-over-downward';
  }

  cls && target.classList[type](cls);
}

export default function Drag(_ref, _ref2) {
  var change = _ref.change,
      columns = _ref.columns;
  var draggable = _ref2.draggable;

  if (!draggable) {
    return {};
  }

  var rowCls = 'jmtd-table-row';
  return {
    rowClassName: 'jmtd-table-plugin-drag-row',
    dragProps: {
      draggable: true,
      onDragStart: function onDragStart(e) {
        dragRowKey = e.target.getAttribute('data-row-key');
        e.target.style.opacity = 0.5;
        e.dataTransfer.effectAllowed = 'move';
      },
      onDragEnter: function onDragEnter(e) {
        var targetNode = getTarget(rowCls, e.target);
        targetNode[COUNT] = (targetNode[COUNT] || 0) + 1;
        setDragCls(targetNode, 'add');
      },
      onDragOver: function onDragOver(e) {
        e.preventDefault();
      },
      onDragLeave: function onDragLeave(e) {
        var targetNode = getTarget(rowCls, e.target);

        if (--targetNode[COUNT] === 0) {
          setDragCls(targetNode, 'remove');
        }
      },
      onDrop: function onDrop(e) {
        var targetNode = getTarget(rowCls, e.target);
        var from = dragRowKey;
        var to = targetNode.getAttribute('data-row-key');
        targetNode[COUNT] = 0;

        if (from !== to) {
          change('dnd', {
            from: from,
            to: to
          });
        }

        setDragCls(targetNode, 'remove');
      },
      onDragEnd: function onDragEnd(e) {
        e.target.style.opacity = 1;
      }
    },
    columns: [{
      fitContent: true,
      title: '',
      drag: true,
      render: function render() {
        return /*#__PURE__*/React.createElement("span", {
          style: {
            pointerEvents: 'none'
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          className: "jmti-ellopsis-v"
        }));
      }
    }].concat(columns)
  };
}